import { TranslationDictionary } from './types';

export const enUS: TranslationDictionary = {
    common: {
        title: 'BimEngine',
        description: 'This is a BIM-ENGINE demo.',
        openTestDialog: 'Open Test Dialog',
        openInfoDialog: 'Open Info Dialog (Wrapped)',
    },
    toolbar: {
        home: 'Home',
        measure: 'Measure',
        zoomBox: 'Zoom Box',
        info: 'Info',
        location: 'Location',
        setting: 'Settings',
        walk: 'Walk',
        map: 'Map',
        property: 'Property',
        fullscreen: 'Fullscreen',
        walkPerson: 'Person',
        walkBird: 'Bird Eye',
        walkMenu: 'Menu',
        tree: 'Tree',
        section: 'Section',
        sectionPlane: 'Plane Section',
        sectionAxis: 'Axis Section',
        sectionBox: 'Section Box',
        cameraSwitch: 'Camera',
    },
    dialog: {
        testTitle: 'Test Dialog',
        testContent: '<div style="padding: 10px;">This is a <b>draggable</b> and <b>resizable</b> dialog.<br><br>Try dragging the title bar or resizing from the bottom-right corner.</div>',
    },
    menu: {
        info: 'Info',
        home: 'Home',
        componentDetail: 'Component Detail',
        hideSelected: 'Hide Selected',
        transparentSelected: 'Transparent Selected',
        cancelTranslucent: 'Cancel Translucent',
        isolateSelected: 'Isolate Selected',
        hideOthers: 'Hide Others',
        transparentOthers: 'Transparent Others',
        fitSectionBox: 'Fit Section Box',
        showAll: 'Show All',
        quickSelect: 'Quick Select',
        selectSameType: 'Select Same Type',
        selectSameLevel: 'Select Same Level',
        selectSameLevelType: 'Select Same Level & Type'
    },
    tree: {
        searchPlaceholder: 'Please enter content to search',
        noResults: 'No matching results',
    },
    constructTree: {
        title: 'Construct Tree',
    },
    componentTreeDrawer: {
        actions: {
            close: 'Close drawer',
            add: 'Add',
            addPin: 'Add Pin',
            addFolder: 'Add Folder',
            edit: 'Edit',
            delete: 'Delete',
            save: 'Save',
            cancel: 'Cancel'
        },
        tabs: {
            view: 'View',
            pin: 'Pins',
            constructTree: 'Component Tree'
        },
        empty: {
            pinTitle: 'No pins yet',
            pinDesc: 'Click the button above to add your first pin'
        },
        defaultNames: {
            pin: 'Pin ',
            folder: 'Folder '
        },
        dialogs: {
            noticeTitle: 'Notice',
            deleteFolderTitle: 'Delete Folder',
            deleteFolderMessage: 'Delete this folder and all pins inside it?',
            deleteFolderMessagePrefix: 'Delete folder "',
            deleteFolderMessageSuffix: '" and all pin data inside it?',
            confirm: 'Confirm'
        },
        placeholders: {
            view: 'View page placeholder. View-related content will be added here later.',
            pin: 'No pins yet. Click the button above to add one.',
            constructTree: 'Component tree placeholder. The new tree capability will be added here later.'
        }
    },
    viewTab: {
        category: {
            ceilingPlans: 'Ceiling Plans',
            elevations: 'Elevations',
            floorPlans: 'Floor Plans',
            sections: 'Sections',
        },
        empty: 'No view data available',
        default3D: 'Default 3D View',
    },
    tab: {
        component: 'Component',
        system: 'System',
        space: 'Space',
        type: 'Type',
        major: 'Major',
    },
    panel: {
        property: {
            title: 'Component Details',
            base: 'Basic Info',
            material: 'Material',
            advanced: 'Advanced',
            tab: {
                props: 'Properties',
                material: 'Material'
            }
        },
        componentDetail: {
            title: 'Component Detail',
            noSelection: 'Please select a component first'
        }
    },
    measure: {
        btnName: 'Measure',
        dialogTitle: 'Measure',
        modes: {
            clearHeight: 'Clear Height',
            clearDistance: 'Clear Distance',
            distance: 'Distance',
            elevation: 'Elevation',
            point: 'Point',
            angle: 'Angle',
            area: 'Area',
            slope: 'Slope',
        },
        actions: {
            expand: 'Expand',
            collapse: 'Collapse',
            clearAll: 'Clear All',
            settings: 'Settings',
        },
        labels: {
            currentMode: 'Mode:',
            x: 'X:',
            y: 'Y:',
            z: 'Z:',
            value: {
                clearHeight: 'Clear Height:',
                clearDistance: 'Clear Distance:',
                distance: 'Distance:',
                elevation: 'Elevation:',
                point: 'Point:',
                angle: 'Angle:',
                area: 'Area:',
                slope: 'Slope:',
            }
        },
        settings: {
            title: 'Settings',
            unit: 'Unit:',
            precision: 'Precision:',
            hint: 'Distance, clear distance, clear height and elevation use this unit by default; angle and area use their own units.',
            save: 'Save',
            cancel: 'Cancel',
        },
        clearHeight: {
            direction: 'Direction:',
            directionDown: 'Down',
            directionUp: 'Up',
            selectType: 'Select:',
            selectPoint: 'Point',
            selectElement: 'Element',
        }
    },
    sectionPlane: {
        dialogTitle: 'Plane Section',
        actions: {
            hide: 'Hide',
            reverse: 'Reverse',
            reset: 'Reset',
            fill: 'Fill'
        }
    },
    sectionAxis: {
        dialogTitle: 'Axis Section',
        actions: {
            hide: 'Hide',
            reverse: 'Reverse',
            reset: 'Reset',
            axisX: 'X',
            axisY: 'Y',
            axisZ: 'Z',
            fill: 'Fill'
        }
    },
    sectionBox: {
        dialogTitle: 'Section Box',
        actions: {
            hide: 'Hide',
            reverse: 'Reverse',
            fitToModel: 'Fit',
            reset: 'Reset',
            fill: 'Fill'
        },
        axes: {
            x: 'X',
            y: 'Y',
            z: 'Z'
        }
    },
    walkControl: {
        speed: 'Speed:',
        gravity: 'Gravity',
        collision: 'Collision',
        characterModel: {
            label: 'Construction Worker',
            constructionWorker: 'Construction Worker',
            officeMale: 'Office Male'
        },
        walkMode: {
            label: 'Walk Mode',
            walk: 'Walk',
            run: 'Run'
        },
        exit: 'Exit',
        path: {
            dialogTitle: 'Path Roaming',
            duration: 'Duration',
            durationUnit: 's',
            loop: 'Loop',
            addPoint: 'Add Point',
            deleteAll: 'Delete All',
            point: 'Point',
            play: 'Play',
            stop: 'Stop',
            noPoints: 'No points yet'
        }
    },
    info: {
        dialogTitle: 'Basic Info',
        meshCount: 'Mesh Count',
        totalTriangles: 'Total Triangles',
        totalVertices: 'Total Vertices',
    },
    aiChat: {
        title: 'AI Assistant',
        placeholder: 'Ask a question...',
        quickPrompt: {
            summarize: 'Summarize this model',
            explain: 'Explain selected component',
            generate: 'Generate report'
        },
        action: {
            new: 'New Chat',
            history: 'History',
            settings: 'Settings',
            close: 'Close'
        },
        helper: {
            newline: 'Shift + Enter for new line',
            send: 'Enter to send'
        },
        thinking: 'Thinking...',
        other: 'Other',
        otherPlaceholder: 'Enter custom answer',
        submit: 'Submit'
    },
    viewDropdown: {
        triggerTitle: 'View Controls',
        switchOrthographic: 'Switch to Orthographic',
        switchPerspective: 'Switch to Perspective',
        saveMainView: 'Set Current as Main View',
        restoreMainView: 'Reset Main View',
        captureScreenshot: 'Capture Screenshot',
    },
    setting: {
        dialogTitle: 'Settings',
        presetSelect: 'Preset',
        presetSelectPlaceholder: 'Select preset',
        defaultPresetLabel: 'Default Preset',
        savePreset: 'Save Preset',
        deletePreset: 'Delete',
        deletePresetForbidden: 'Default preset cannot be deleted',
        presetDefaultName: 'Preset',
        presetNamePrompt: 'Enter preset name',
        presetNameRequired: 'Preset name is required',
        presetNameDuplicate: 'Preset name already exists',
        restorePreset: 'Restore Preset',
        saveAsNewPreset: 'Save As Preset',
        selectPresetFirst: 'Please select a preset first',
        presetButton: 'Preset',
        undoChanges: 'Undo Changes',
        saveAsDialogTitle: 'Save As Preset',
        deleteDialogTitle: 'Delete Preset',
        deleteDialogMessage: 'Delete current preset? This action cannot be undone.',
        presetNamePlaceholder: 'Enter preset name',
        confirm: 'Confirm',
        cancel: 'Cancel',
        presetPickPrompt: 'Please input preset number',
        presetPickInvalid: 'Invalid preset number',
        renderMode: 'Render Mode',
        modes: {
            simple: 'Performance',
            balance: 'Balanced',
            advanced: 'Quality',
        },
        displaySection: 'Display',
        edgeLine: 'Edge Lines',
        edgeOpacity: 'Edge Opacity',
        showGrid: 'Show Grid',
        showLevel: 'Show Level',
        contrast: 'Contrast',
        saturation: 'Saturation',
        lightIntensity: 'Light Intensity',
        environment: 'Environment',
        environmentType: {
            none: 'None',
            hdr: 'HDR',
            sky: 'Sky',
        },
        backgroundVisible: 'Show Background',
        ground: 'Ground',
        groundElevation: 'Ground Elevation',
        groundElevationUnit: 'm',
    },
    help: {
        engineControl: 'Engine Controls',
        fpsControl: 'First Person Controls',
        gotIt: 'Got it',
        dontRemind: 'Don\'t remind me again',
        rotate: 'Rotate',
        mouseLeftDrag: 'Left mouse drag',
        pan: 'Pan',
        shiftLeftDrag: 'Shift + Left/Right drag',
        zoom: 'Zoom',
        mouseWheel: 'Mouse wheel',
        boxSelect: 'Box Select',
        ctrlLeftDrag: 'Ctrl + Left drag',
        multiSelect: 'Add/Remove Selection',
        ctrlShiftClick: 'Ctrl + Click (Add) / Shift + Click (Remove)',
        homeView: 'Home View',
        doubleClickBlank: 'Double click empty area',
        rotateRuleTitle: 'Rotation Center Rule',
        rotateRuleDesc: 'Hovering over a component sets the rotation center to that position; hovering over empty area keeps the last rotation center.',
        roam: 'Roam',
        or: 'or',
        upDown: 'Move Up/Down',
        qeKey: 'Q / E',
        landOnFloor: 'Enable gravity to land on nearest floor',
        run: 'Run (Speed up)',
        shiftArrow: 'Shift + Arrow keys',
        teleport: 'Teleport',
        doubleClick: 'Double click target',
        lookAround: 'Look Around',
        leftDrag: 'Drag view with left button',
        adjustSpeed: 'Adjust Speed',
        rotateView: 'Rotate View',
        panView: 'Pan View',
        zoomView: 'Zoom View',
        resetView: 'Reset View',
        mouseLeftDragShort: 'Left mouse drag',
        mouseRightDragShort: 'Right-click and drag / Shift + Left-click',
        mouseWheelShort: 'Scroll mouse wheel',
        componentSelect: 'Component Selection',
        click: 'Click',
        addSelect: 'Add to selection',
        removeSelect: 'Remove from selection',
        doubleClickBlankShort: 'Double click empty area',
        pointToComponent: 'Point to component:',
        pointToComponentDesc: 'Set rotation center at click position',
        pointToBlank: 'Point to blank:',
        pointToBlankDesc: 'Keep last rotation center',
        roamMove: 'Roam Move',
        roamMoveDesc: 'Use WASD keys to move',
        speedUp: 'Speed Up',
        lookAroundDesc: 'Drag view with left button',
        teleportDesc: 'Double click target component or ground',
    }
};
